import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

declare const Pusher: any;

@Injectable({
    providedIn: 'root',
})
export class PusherService {
    pusher: any;
    channel: any;

    constructor() {
        // Initialize Pusher
        this.pusher = new Pusher(environment.pusher.key, {
            cluster: environment.pusher.cluster,
            encrypted: true,
        });
    }

    // Subscribe to a Pusher channel
    subscribe(channelName: string): void {
        this.channel = this.pusher.subscribe(channelName);
    }

    unbind(channelName: string, eventName: string): void {
        const channel = this.channel[channelName];
        if (channel) {
            //console.log(`Unbinding event: ${eventName} from channel: ${channelName}`);
            channel.unbind(eventName);
        } else {
            //console.warn(`Channel ${channelName} is not subscribed.`);
        }
    }

    // Bind an event to the Pusher channel
    bind(eventName: string, callback: Function): void {

        if (this.channel) {
            this.channel.bind(eventName, (data: any) => {
                callback(data);
            });
        }
    }

    // Unsubscribe from the channel
    unsubscribe(channelName: string): void {
        if (this.pusher) {
            this.pusher.unsubscribe(channelName);
        }
    }
}